// extracted by mini-css-extract-plugin
module.exports = {"container":"WhatsInTheBoxSegment-Container-module--container--1M4e0 utils-module--flex-wrap-pad-6--2xVOF"};